import React, { useEffect, useRef, useState } from 'react';
import * as S from './Header.style';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import { AuthContext } from '../../context/Auth/AuthContext';
import { useContext } from 'react';
import assets from 'assets';
import { colors } from 'utils/colors';
import MenuIcon from '@mui/icons-material/Menu';
import ModalPassword from 'components/ModalPassword/ModalPassword.component';

type TMenuDetails = {
  setCloseMobile?: () => void;
};

const Menuitens = ({ setCloseMobile }: TMenuDetails) => {
  const auth = useContext(AuthContext);

  //Parte do modal pass
  const [openPass, setOpenPass] = useState(false);
  const [itemPass, setItemPass] = useState('');

  //Parte do modal password
  const handlePass = () => {
    if (auth?.user?.id) {
      setItemPass(auth.user.id);
      setOpenPass(true);
    }
  };

  const hadleLogout = () => {
    auth.signout();
  };

  return (
    <>
      <S.Linkcomponent
        to="/vendedor/kanban"
        onClick={() => (setCloseMobile ? setCloseMobile() : '')}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Kanban/Orçamentos
      </S.Linkcomponent>
      <S.Linkcomponent
        to="/vendedor/orcamento"
        onClick={() => (setCloseMobile ? setCloseMobile() : '')}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Lista/Orçamentos
      </S.Linkcomponent>
      <S.Linkcomponent
        to="/vendedor/listaClientes"
        onClick={() => (setCloseMobile ? setCloseMobile() : '')}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Clientes
      </S.Linkcomponent>
      <S.Linkcomponent
        to="/vendedor/cadastroCliente"
        onClick={() => (setCloseMobile ? setCloseMobile() : '')}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Cadastro Cliente
      </S.Linkcomponent>
      <S.Linkcomponent
        to={'/vendedor/listLead'}
        onClick={() => (setCloseMobile ? setCloseMobile() : '')}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Leads
      </S.Linkcomponent>
      <S.Linkcomponent
        to={'/vendedor/preLead/'}
        onClick={() => (setCloseMobile ? setCloseMobile() : '')}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Cadastro Pré-Lead
      </S.Linkcomponent>
      <a
        style={{ color: '#000', marginLeft: '15px' }}
        href="https://primaza.com.br/produtos/"
        target="_blank"
        rel="noreferrer"
      >
        Produtos
      </a>
      {auth.user.permissions.includes('Admin') ? (
        <S.Linkcomponent
          to="/admin/orcamento/"
          onClick={() => (setCloseMobile ? setCloseMobile() : '')}
          style={({ isActive }) => {
            return {
              color: isActive ? colors.verde : 'unset',
              fontWeight: isActive ? 700 : 500,
            };
          }}
        >
          Painel Admin
        </S.Linkcomponent>
      ) : (
        <S.Linkcomponent
          to=""
          onClick={() => handlePass()}
          style={({ isActive }) => {
            return {
              color: isActive ? colors.verde : 'unset',
              fontWeight: isActive ? 700 : 500,
            };
          }}
        >
          Meu Login
        </S.Linkcomponent>
      )}
      <S.Linkcomponent
        to="/"
        onClick={() => hadleLogout()}
        style={({ isActive }) => {
          return {
            color: isActive ? colors.verde : 'unset',
            fontWeight: isActive ? 700 : 500,
          };
        }}
      >
        Sair
      </S.Linkcomponent>

      <ModalPassword path={'pass'} id={itemPass} open={openPass} setOpen={setOpenPass} isAdmin />
    </>
  );
};

const Header = () => {
  const [actieMenu, setActiveMenu] = useState<boolean>(false);
  const headerRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (headerRef.current && !headerRef.current.contains(event.target as Node)) {
      setActiveMenu(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  function handleMenuActive() {
    if (actieMenu) {
      return setActiveMenu(false);
    } else {
      setActiveMenu(true);
    }
  }

  return (
    <>
      <S.ContainerHeader>
        <S.ConteudoContainer>
          <S.ColumContainer logo>
            <img src={assets.images.logo} />
          </S.ColumContainer>
          <S.ColumContainer primary>
            <S.MenuItems>
              <Menuitens />
            </S.MenuItems>
            <S.MobileMenu style={{ zIndex: actieMenu ? '-1' : 0 }}>
              <MenuIcon onClick={handleMenuActive} />
            </S.MobileMenu>
            <S.OtherItems>
              <S.SocialMidia
                onClick={() => {
                  window.location.href = 'https://instagram.com/primaza.br';
                }}
              >
                <InstagramIcon style={{ fontSize: '18px' }} />
              </S.SocialMidia>
              <S.SocialMidia
                onClick={() => {
                  window.location.href = 'https://facebook.com/primaza.br';
                }}
              >
                <FacebookIcon style={{ fontSize: '18px' }} />
              </S.SocialMidia>
              <S.BoxContato>
                <S.TextConteudo>vendas</S.TextConteudo>
                <S.TextConteudo primary>(55) 98154-0054</S.TextConteudo>
              </S.BoxContato>
            </S.OtherItems>
          </S.ColumContainer>
        </S.ConteudoContainer>
      </S.ContainerHeader>
      {actieMenu && (
        <S.BoxMobileMenu ref={headerRef}>
          <Menuitens setCloseMobile={() => setActiveMenu(false)} />
        </S.BoxMobileMenu>
      )}
    </>
  );
};

export default Header;
